import Icon1 from "../icons/Icon";

import FacturePaymentVisualisateur from "./FacturePaymentVisualisateur";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { useState } from "react";
import Modal1 from "../modals/Modal1";
import Payment from "./PaymentModal";
import createDocApi from "../api/database/createDocApi";
import { folder } from "jszip";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import { EasySwitch } from "../textfields/EasySwitch";
import WarningButton from "../buttons/WarningButton";
import UploadRapportPayment from "../api/upload/UploadRapportPayment";
import PaymentRapportVisualisateur from "./PaymentRapportVisualisateur";
import PaymentModal from "./PaymentModal";
import getTemporaryUrlV2 from "../api/getTemporaryUrlV2";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";

const ReglementArchitecteClient = ({
  orgData,
  userData,
  folderData,
  clientData,
  reglement,
  setReglement,
  payments,
  setPayments,

  handleUpdateReglement,
  handleFetchData,

  loadingTransfer,
  setLoadingTransfer,
  transferFiles,
  dropped_exists,
  navigateWorkspace,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [payment_open, setPaymentOpen] = useState(null);
  const theme = useTheme();
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const handleLoadInvoice = async (invoice) => {
    if (invoice.file.id) {
      setLoadingInvoice(invoice.file.id);
      const token = await getOrRefreshFirebaseToken();
      let refreshed_url = await getTemporaryUrlV2(
        invoice.file.id,
        token,
        prefix
      );
      if (refreshed_url) {
        window.open(refreshed_url, "_blank");
      } else {
        handleClickVariant("Impossible de charger le fichier", "error");
      }
      setLoadingInvoice(false);
    }
  };
  return (
    <div className="flex flex-col w-full h-fit gap-2 justify-end items-start ">
      <div className="flex flex-row h-fit gap-2 justify-end items-start w-full">
        {payment_open && (
          <div className="absolute w-screen h-screen  z-10">
            <Modal1
              isOpen={payment_open !== null}
              onClose={() => setPaymentOpen(null)}
            >
              <PaymentModal
                orgData={orgData}
                folder={folderData}
                userData={userData}
                paymentData={payments[payment_open]}
                index={payment_open}
                onClose={() => setPaymentOpen(null)}
                onUpdate={handleFetchData}
                navigateWorkspace={navigateWorkspace}
              ></PaymentModal>
            </Modal1>
          </div>
        )}
      </div>
      <div className="border-1 border-shadow_10 h-fit rounded-lg flex flex-col p-1 gap-1 w-full">
        <div className="flex flex-col gap-1 text-h3 text-black h-fit p-1">
          Devis
          <div className="flex flex-col gap-2 p-1 mb-2">
            {folderData.invoices?.map((invoice) => (
              <div className="bg-white px-2 py-1 flex flex-row w-fit gap-1 rounded-full  text-h4 text-shadow_50 border-1 border-shadow_10">
                <div
                  onClick={() => handleLoadInvoice(invoice)}
                  className="hover:text-indigo-500 hover:underline cursor-pointer"
                >
                  {invoice.file.name?.substring(0, 50)}
                </div>
                {loadingInvoice === invoice.file.id && (
                  <SmallSpinner></SmallSpinner>
                )}
              </div>
            ))}
          </div>
          Rapports pour chaque paiements
          <div className="flex flex-col gap-2 p-1">
            {payments?.map((slot, index) => (
              <div
                key={index}
                className={`flex flex-col gap-1  border-1 text-h2 ${["initiated", "opened", "pending"].includes(payments[index]?.state) ? "bg-orange-100 border-orange-400 " : payments[index]?.state === "paid" ? "bg-teal-50 border-teal-300 " : payments[index]?.state === "error" ? "bg-red-50 border-red-300 " : "bg-slate-100 border-slate-300"}  rounded-xl p-2`}
              >
                <div className=" w-fit text-h3 text-indigo-500 font-semibold">
                  {payments[index]?.title ||
                    "emplacement de paiement " + (index + 1)}
                </div>

                <div className="flex flex-row gap-4 relative">
                  <div className="flex flex-col gap-2 p-1 w-c200 min-w-c200 ">
                    <div className="text-h3 text-shadow_50 ">Facture </div>

                    <div className="flex flex-row gap-2">
                      {!payments[index]?.facture_file && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Pas de facture
                        </div>
                      )}
                      {payments[index]?.facture_file && (
                        <div className=" text-h4  text-shadow_50  w-fit">
                          {payments[index]?.facture_file?.name}
                        </div>
                      )}
                    </div>

                    <FacturePaymentVisualisateur
                      folder={folderData}
                      payment_id={payments[index].id}
                      orgData={orgData}
                      prefix={prefix}
                    ></FacturePaymentVisualisateur>
                  </div>
                  <div className="flex-grow flex flex-col gap-2  rounded-lg p-1 border-shadow_10">
                    <div className="text-h3 text-shadow_50">
                      Rapports{" "}
                      {payments[index]?.state !== "paid" && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Paiement en attente
                        </div>
                      )}
                      {payments[index]?.rapport_files === "paid" &&
                        payments[index]?.rapport_files?.length === 0 && (
                          <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                            <Icon1
                              icon_name="done2"
                              size={20}
                              fill={"#4ade80"}
                            ></Icon1>
                            Rapports
                            <span className="text-green-400 font-semibold inline-block">
                              disponibles
                            </span>
                          </div>
                        )}
                    </div>

                    <div className="flex flex-row gap-2 ">
                      {(!payments[index]?.rapport_files ||
                        payments[index]?.rapport_files?.length === 0) &&
                        payments[index]?.state === "paid" && (
                          <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                            <Icon1
                              icon_name="linked_file"
                              size={20}
                              fill={"grey"}
                            ></Icon1>
                            Pas de rapports
                          </div>
                        )}
                      {payments[index]?.rapport_files?.length > 0 && (
                        <div className=" text-h4 flex flex-col gap-1 text-shadow_50  w-fit">
                          {payments[index]?.rapport_files?.map(
                            (file, index) => (
                              <div
                                className="  border-l-1 border-green-300 rounded-sm px-1"
                                key={index}
                              >
                                {file.name}
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                    {payments[index]?.state === "paid" && (
                      <PaymentRapportVisualisateur
                        folder={folderData}
                        userData={userData}
                        payment_id={payments[index].id}
                        orgData={orgData}
                        prefix={prefix}
                        handleUpdate={handleFetchData}
                      ></PaymentRapportVisualisateur>
                    )}
                  </div>{" "}
                  <div className="absolute top-1 right-1 text-h3 text-shadow_50 flex flex-row justify-end w-fit gap-1 ">
                    <div className="flex flex-col gap-2 items-end w-fit">
                      {payments[index]?.state === "paid" && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400">
                            Payé
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}{" "}
                      {payments[index]?.downloaded === true && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400 ">
                            Reçu
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}
                      {["initiated", "opened", "pending"].includes(
                        payments[index]?.state
                      ) && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-orange-500">
                            En attente
                          </div>
                          <Icon1
                            icon_name="horloge"
                            size={18}
                            fill={"#f97316"}
                          ></Icon1>
                        </div>
                      )}{" "}
                    </div>{" "}
                  </div>
                </div>
              </div>
            ))}

            <Space y={2} />

            {payments.length === 0 && (
              <div className="text-h3 text-shadow_50">Aucun paiement créé</div>
            )}
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default ReglementArchitecteClient;
